import React from "react";
import moment from "moment";
import classnames from "classnames";
import { isEmpty, map } from "lodash";
import { Empty, Typography } from "antd";
import { DATETIME_FORMAT } from "constants/common";
import { AiccConversationAudio, AiccConversationMessage } from "types/model/aiccCustomer";
import AudioPlayButton from "./AudioPlayButton";
import UserFeedback from "./UserFeedback";
import MessageFeedback from "./MessageFeedback";
import styles from "./Transcript.module.scss";

interface Props {
  messages: AiccConversationMessage[];
  audio: AiccConversationAudio;
}

const AI_SENDER = "AI";
const USER_SENDER = "User";

function Transcript({ messages, audio }: Props) {
  if (isEmpty(messages)) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No messages." />;
  }

  return (
    <div>
      {map(
        messages,
        ({
          id,
          isUser,
          content,
          sentAt,
          translation,
          transliteration,
          userFeedback,
          grammarFeedback,
          pronunciationFeedback,
        }) => (
          <div key={id} className={classnames(styles.row, isUser ? styles.userRow : styles.aiRow)}>
            <div className={classnames(styles.bubble, isUser ? styles.userBubble : styles.aiBubble)}>
              <div className={styles.header}>
                {isUser ? USER_SENDER : AI_SENDER}
                <UserFeedback value={userFeedback} />
                {audio[id] && <AudioPlayButton url={audio[id]} />}
                <span className={styles.sentAt}>{moment(sentAt).format(DATETIME_FORMAT)}</span>
              </div>

              <Typography.Paragraph className={styles.content}>{content}</Typography.Paragraph>

              {transliteration && <div className={styles.secondaryText}>{transliteration}</div>}
              {translation && <div className={classnames(styles.secondaryText, styles.translation)}>{translation}</div>}

              <MessageFeedback grammarFeedback={grammarFeedback} pronunciationFeedback={pronunciationFeedback} />
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default Transcript;
